import { render, staticRenderFns } from "./SkuManage.vue?vue&type=template&id=128537aa&scoped=true"
import script from "./SkuManage.vue?vue&type=script&lang=js"
export * from "./SkuManage.vue?vue&type=script&lang=js"
import style0 from "./SkuManage.vue?vue&type=style&index=0&id=128537aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128537aa",
  null
  
)

export default component.exports